import React, { FC } from 'react'
import cx from 'classnames'

import { Image } from '../../types'

import * as SC from './styled'
import { FooterContactProps } from './FooterContact'
import { FooterProductProps } from './FooterProduct'
import { FooterLegalProps } from './FooterLegal'
import { FooterDisclaimerProps } from './FooterDisclaimer'

export type FooterProps = {
  className?: string
  disclaimer?: FooterDisclaimerProps
  logo: Image & { logoLink?: string }
  contact: FooterContactProps
  product: FooterProductProps
  legal: FooterLegalProps
}

const Footer: FC<FooterProps> = (props) => {
  const { className, logo, contact, product, legal, disclaimer } = props

  return (
    <SC.Container className={cx(className)}>
      <SC.FirstWrapper>
        {disclaimer && <SC.Disclaimer {...disclaimer} />}

        <SC.Wrapper>
          <SC.Column>
            <SC.DefaultLink href={logo?.logoLink}>
              <SC.Logo src={logo.src} alt={logo.alt} />
            </SC.DefaultLink>
            <SC.Product {...product} />
          </SC.Column>
          <SC.Column>
            <SC.Contact {...contact} />
          </SC.Column>
          <SC.Column>
            <SC.Legal {...legal} />
          </SC.Column>
        </SC.Wrapper>
      </SC.FirstWrapper>
    </SC.Container>
  )
}

export default Footer
